
    import '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/checkbox.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-weet-checkbox-demo-basic","docs-weet-checkbox-demo-disable","docs-weet-checkbox-demo-select-all","docs-weet-checkbox-demo-layout"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/checkbox.md?type=demo')
};